import moment from 'moment';

export const getProjectTime = (timezoneOffset, dateValue) => {
  // Returns 12 noon on project time for given date (this changes time instant)
  if (!dateValue) return undefined;
  const date = moment(dateValue);
  return moment([
    date.year(),
    date.month(),
    date.date(),
    12,
    0,
    0,
  ]).utcOffset(timezoneOffset * 60, true);
};

export const formatDate = (timezoneOffset, dateValue, format) => {
  const formatString = format || 'L';
  return dateValue
    ? moment(dateValue)
        .utcOffset(timezoneOffset * 60)
        .format(formatString)
    : 'Unspecified';
};

// export const localToTimeZone: dateValue =>
//   dateValue ? moment(dateValue).utcOffset(-(timezoneOffset * 60)): undefined;

// export const timeZoneToLocal: dateValue =>
//   dateValue ? moment(dateValue).utcOffset(timezoneOffset * 60) : undefined;



// WEBPACK FOOTER //
// ./src/helpers/timezone.js